import React, { FC, ReactNode, useCallback, useContext } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { StylableComponent, stylePropType } from '@adsk/alloy-react-helpers';
import {
  ViewDensityNarrowIcon,
  ViewDensityStandardIcon,
  ViewDensityWideIcon,
} from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import { TABLE_SIZES } from '../consts';
import TableSizeThemeContext from '../TableSizeThemeContext';
import { TableSize } from '../types';
import DensityOption from './DensityOption';

const MenuHeading = styled.div({
  ...theme.typography.heading4,
  color: theme.colors.charcoal700,
  padding: '14px 24px',
});

type TableConfigurationDensityProps = StylableComponent<HTMLDivElement> & {
  label: ReactNode;
  setSize: (size: TableSize) => void;
};

const TableConfigurationDensity: FC<TableConfigurationDensityProps> = ({
  label,
  setSize,
  className,
  style,
}) => {
  const { tableSizeTheme } = useContext(TableSizeThemeContext);
  return (
    <div
      className={className}
      css={[
        {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        style,
      ]}
    >
      <MenuHeading>{label}</MenuHeading>
      <div
        css={[
          {
            display: 'flex',
            padding: '0 16px',
          },
        ]}
      >
        <DensityOption
          setSize={setSize}
          size={TABLE_SIZES.SMALL}
          renderIcon={useCallback(
            (p) => (
              <ViewDensityNarrowIcon {...p} />
            ),
            []
          )}
          currentSize={tableSizeTheme.size}
        />
        <DensityOption
          setSize={setSize}
          size={TABLE_SIZES.MEDIUM}
          renderIcon={useCallback(
            (p) => (
              <ViewDensityStandardIcon {...p} />
            ),
            []
          )}
          currentSize={tableSizeTheme.size}
        />
        <DensityOption
          setSize={setSize}
          size={TABLE_SIZES.LARGE}
          renderIcon={useCallback(
            (p) => (
              <ViewDensityWideIcon {...p} />
            ),
            []
          )}
          currentSize={tableSizeTheme.size}
        />
      </div>
    </div>
  );
};

TableConfigurationDensity.propTypes = {
  label: PropTypes.node.isRequired,
  setSize: PropTypes.func.isRequired,
  style: stylePropType,
  className: PropTypes.string,
};

export default TableConfigurationDensity;
